import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/parts");
export const getIdPath = returnPath("/parts/:id");

export const getPartCreateMultiPath = returnPath("/parts/part-create-multi");